function RadioProducer(props) {

    return (
        <div className="recruit_contents">
            <div className="recruit_titleline_w">
                <h4 className="recruit_titleline_info">제작</h4>
                <h5 className="recruit_titleline_title">라디오PD</h5>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">직무소개</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">직무 및 필요역량</h7>
                <p className="recruit_subinfo_text">
                    라디오 PD는 라디오 프로그램을 기획, 제작, 연출합니다. 나아가 프로그램 전체를 책임지는 자리에 있는 사람입니다.<br />
                </p>
                <ol className="recruit_subinfo_list">
                    <li className="recruit_subinfo_list_inner">아무래도 라디오 특성상 생방송이 많다 보니 순발력과 빠른 대처 능력이 필요합니다. 동시에 생방송이기에 발생할 수 있는 사고들을<br />미연에 방지할 수 있는 철저한 준비성이 필요합니다.</li>
                    <li className="recruit_subinfo_list_inner">라디오 PD는 ‘눈치’가 필요합니다. PD는 프로그램이 원활하게 굴러갈 수 있도록 DJ, 작가, 엔지니어 등 협업하는 모든 이들의 상황을<br /> 파악하고 있어야 합니다. 또, 청취자들이 어떤 것에 반응하는지를 보고 눈치 빠르게 프로그램에 반영해야 합니다.</li>
                    <li className="recruit_subinfo_list_inner">사람과 사회에 대한 관심이 필요합니다. 이는 프로그램 제작에 있어 필요한 대중문화 및 사회 이슈를 포착하는 감각을 의미합니다.</li>
                </ol>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">부서 소개</h7>
                <p className="recruit_subinfo_text">
                    라디오센터는 크게 제작, 전략, 운영의 세 파트로 나뉘고, SBS에서 라디오 제작기술을 제외한 모든 것을 총괄하는 부서입니다.
                </p>
                <em className="recruit_bold_text">제작CP</em>
                <p className="recruit_subinfo_text">
                    러브FM, 파워FM의 모든 프로그램을 제작합니다.
                </p>
                <em className="recruit_bold_text">전략</em>
                <p className="recruit_subinfo_text">
                    라디오 편성과 운행을 책임지며, 앞으로 라디오센터가 나아가야 할 모습을 그려갑니다.<br />
                    각 프로그램의 홍보와 마케팅, 수익사업 추진, 성과 분석과 청취율 조사도 전략파트의 주요 업무입니다.
                </p>
                <em className="recruit_bold_text">운영</em>
                <p className="recruit_subinfo_text">
                    라디오센터의 예산을 편성하고 집행하며, 프로그램 제작 관련 계약체결도 운영파트의 업무입니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">커리어패스 및 비전</h7>
                <p className="recruit_subinfo_text">
                    입사 초기에는 시사 프로그램부터 음악 프로그램까지 다양한 프로그램을 경험하며 PD로서의 소양을 쌓습니다. 그리고 이를 바탕으로<br /> 하나의 프로그램을 책임지고 연출합니다.
                    매일 생방송으로 청취자와 소통하고, 다양한 이슈를 접하며 업무에 생동감을 느낄 수 있습니다.<br />
                    나아가 라디오, 팟캐스트 등 오디오 콘텐츠에 국한되지 않고 보는 라디오, 유튜브 등 영상 크리에이터로서의 꿈도 펼칠 수 있습니다.
                </p>
            </div>
            <div className="recruit_subtitleline_w">
                <h6 className="recruit_titleline_info">선배인터뷰</h6>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인 소개</h7>
                <p className="recruit_subinfo_text">
                    SBS 라디오 PD 정혜윤입니다.<br /> 입사 후 프로그램을 제작하다가 현재는 라디오콘텐츠전략팀에서 유튜브, 팟캐스트 등을 담당하고 있습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">라디오PD가 된 계기는?</h7>
                <p className="recruit_subinfo_text">
                    잠이 안 오는 새벽에 엄마 몰래 이불 속에서, 야자 시간에 터져 나오는 웃음을 참으며 라디오를 들었던 저는 '라디오키즈' 였습니다.<br />
                    흔히 라디오를 일방향적인 올드 미디어라고 합니다. 하지만 저는 청취자들의 문자와 신청곡으로 프로그램이 구성되는 라디오야말로 사람들과 끊임없이 소통하는 미디어라고 생각했고,
                    이게 라디오의 가장 큰 매력이라 확신했습니다.<br />
                    사람들과 티키타카 하며 생각이 멈춰있지 않은 삶을 살고 싶은 제게, 라디오는 살아있는 미디어였고 자연스럽게 라디오PD도 꿈꾸게 됐습니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">본인의 일에서 보람을 느낄 때는?</h7>
                <p className="recruit_subinfo_text">
                    아침 6시 프로그램을 연출할 때, 청취 인증샷 이벤트를 했습니다. <br />
                    겨울이라 해가 늦게 떠서 온 세상이 깜깜해 누가 이 방송을 듣고 있나 싶었습니다. 그러나 이내 쏟아지는 청취자들의 인증 문자에 제 걱정이<br />
                    깨끗이 없어지는 경험을 했습니다.<br />
                    형광색 미화복을 입은 환경미화원, 마감하고 퇴근길에 오른 택시 기사, 물건을 한가득 싣고 달리는 대형 트럭 기사, 아침 운동을, 아침 식사<br />
                    준비를 하는 사람까지.. 이른 시간부터 아침을 맞이하는 청취자들의 모습은 다양했습니다. 청취자들이 보낸 사진 한 장 한 장마다 희로애락이<br />
                    느껴졌고, 설명할 수 없는 무언가가 제 마음을 울렸습니다.<br />
                    또 청취자분들이 보내주신 &#34;정말 재밌었어요.&#34;, &#34;감동했어요.&#34; 와 같은 실시간 문자를 읽을 때, 제작 과정에서의 피로감이 사라지고,<br />
                    프로그램을 더 잘 만들고 싶다는 욕심과 사명감이 생깁니다.
                </p>
            </div>
            <div className="recruit_cont">
                <h7 className="recruit_subtitle">입사지원자에게 해주고 싶은 말</h7>
                <p className="recruit_subinfo_text">
                    매일 같은 시간에 진행되는 데일리 방송이, 라디오라는 매체 자체가 지루하고 따분하다고 생각할 수도 있습니다. 하지만 라디오PD는<br />
                    매일 조금씩 앞으로 나아가는 사람들로, 어제보다 오늘 방송을, 오늘보다는 내일 방송을 더 좋게 만들고 싶다는 마음으로 하루를 살아갑니다. <br />
                    일상 속에서 재미와 즐거움을 찾아가며 함께 걸어나갈 동료를 반갑게 기다리고 있겠습니다.<br />
                    아, 라디오 PD는 PD로서의 창작 욕구를 충분히 충족하면서도 워라밸을 지킬 수 있습니다는 큰 장점도 있었네요^^<br />
                    같이 일할 날을 기다리겠습니다.
                </p>
            </div>
        </div>);
}

export default RadioProducer;

